/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'saled': {
    width: 28,
    height: 17,
    viewBox: '0 0 28 17',
    data: '<path pid="0" _fill="#fc0" d="M11.02 7.509l1.82 1.72 4.14-3.912a1.235 1.235 0 011.676 0 1.077 1.077 0 010 1.584l-5.029 4.752a1.235 1.235 0 01-1.676 0 1.12 1.12 0 01-.237-.32l-2.37-2.24a1.077 1.077 0 010-1.584 1.234 1.234 0 011.676 0zm15.886-1.121c-1.206 0-2.187.952-2.187 2.122s.981 2.123 2.187 2.123H28V17H0v-6.367h1.094c1.206 0 2.187-.952 2.187-2.123 0-1.17-.981-2.122-2.187-2.122H0V.021h.028L.026.016.06 0h5.128l-.046.02h16.281L21.412 0h3.495c.1.013.2.02.304.02H28v6.368zm-1.094-4.245H2.187V4.4c1.885.472 3.282 2.136 3.282 4.11 0 1.975-1.397 3.639-3.282 4.11v2.258h23.625V12.62c-1.884-.472-3.28-2.136-3.28-4.11 0-1.975 1.396-3.639 3.28-4.111z"/>'
  }
})
